const MOBILE_TOOLBAR_HEIGHT = 59;
const TABLET_TOOLBAR_HEIGHT = 51;

/*
*  Detect device type by reading computed style that is set by media queries in CSS
*  It uses z-index for this purpose, but it can be any numeric property
*  @returns {string} one of wide | desktop | tablet | mobile
* */
export function getDeviceType() {
  const detectorClass = 'dc-device-detector';
  const deviceTypeMapping = {
    0: 'wide',
    1: 'desktop',
    2: 'tablet',
    3: 'mobile'
  };
  const defaultDeviceType = 1;
  let detectorElement;
  detectorElement = document.querySelector(`.${detectorClass}`);
  if (detectorElement === null) {
    detectorElement = document.createElement('div');
    detectorElement.className = detectorClass;
  }
  document.querySelector('body').appendChild(detectorElement);
  const detectedValue = window.getComputedStyle(detectorElement).getPropertyValue('z-index');
  return Number.isNaN(detectedValue)
    ? deviceTypeMapping[defaultDeviceType]
    : deviceTypeMapping[detectedValue];
}
/**
 * @link http://stackoverflow.com/a/4819886
 *
 * @returns {boolean}
 */
export function supportsTouch() {
  if (typeof window === 'undefined') {
    return false;
  }
  return !!('ontouchstart' in window) || !!('msmaxtouchpoints' in window.navigator);
}

export function browser() {
  const deviceType = getDeviceType();
  let stickyHeaderOffset = 0;
  if (deviceType === 'mobile') {
    stickyHeaderOffset = MOBILE_TOOLBAR_HEIGHT;
  }
  if (deviceType === 'tablet') {
    stickyHeaderOffset = TABLET_TOOLBAR_HEIGHT;
  }
  return {
    deviceType: deviceType,
    stickyHeaderOffset: stickyHeaderOffset,
    supportsTouch: supportsTouch()
  };
}
